import axios from "axios";

import { AI_ASSISTANT_BASE_URL } from "src/common/constants";
export default class AIAssistantChatService {
    static instance;

    static getInstance() {
        if (!AIAssistantChatService.instance) {
            AIAssistantChatService.instance = new AIAssistantChatService();
        }

        return AIAssistantChatService.instance;
    }

    async fetchUserChatHistory({
        userId, 
        companyId = 'default_company', 
        params = {}
    }) {
        const response = await axios.get(
            `${AI_ASSISTANT_BASE_URL}/history/${companyId}/${userId}`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }

    async askQuestion(payload) {
        const response = await axios.post(
            `${AI_ASSISTANT_BASE_URL}/chat`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }
}